var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConjunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.838,16.013L52.153,42.698c-3.709-2.539-8.19-4.028-13.014-4.028c-12.736,0-23.098,10.361-23.098,23.098  s10.361,23.098,23.098,23.098s23.098-10.361,23.098-23.098c0-5.751-2.118-11.014-5.608-15.061L83.08,20.255  c1.172-1.172,1.172-3.071,0-4.242C81.908,14.841,80.01,14.841,78.838,16.013z M39.139,78.866c-9.428,0-17.098-7.67-17.098-17.098  s7.67-17.098,17.098-17.098s17.098,7.67,17.098,17.098S48.566,78.866,39.139,78.866z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConjunction);
export default __webpack_public_path__ + "static/media/conjunction.5ef896b15b189d360b3fd758eb13ff9b.svg";
export { ForwardRef as ReactComponent };